// The new, streamlined interface (9 October 2026): the export markets.
export default {
  titre: 'Export markets',
  sousTitre: 'Each country is read through its own formats: {n} benchmarks, their launch audience, how much its population wants to watch them',
  sousTitreSansNombre: 'Each country is read through its own formats: their launch audience, how much its population wants to watch them',
  erreur: {
    liste: 'Countries could not be read',
    releve: 'Fetch refused',
    etalonnage: 'Benchmarking refused',
  },
  chiffres: {
    sur: 'of {n}',
    etalonnes: 'countries benchmarked, ready to receive a format',
    audiences: 'benchmark audiences approved',
  },
  carte: {
    invitation: 'Start with a country where your formats stand a chance: it is benchmarked in one go.',
    prets: '{n} countries have enough approved benchmarks to be benchmarked right away. | {n} country has enough approved benchmarks to be benchmarked right away. | {n} countries have enough approved benchmarks to be benchmarked right away.',
    tousEtalonnes: 'Every export market has its benchmark run.',
    choisir: 'Country to benchmark',
    option: '{pays} ({n} of {total})',
  },
  regions: {
    libelle: 'Regions',
    tous: 'All countries',
    europe: 'Europe',
    ameriques: 'Americas',
    asieOceanie: 'Asia and Oceania',
    afrique: 'Africa',
    moyenOrient: 'Middle East',
    autres: 'Other',
  },
  legende: 'Export markets and their benchmark formats',
  colonne: {
    pays: 'Country',
    etalons: 'Approved benchmarks',
    etat: 'Status',
    action: 'Action',
  },
  reference: 'Reference',
  etalonsSur: '{n} of {total}',
  aValider: '{n} to approve',
  etat: {
    aEtalonner: 'To benchmark',
    etalonneLe: 'Benchmarked on {moment}',
  },
  suite: {
    voir: 'See the benchmark run',
    suivre: 'Follow the benchmark run',
    relire: 'Review the protocol',
    etalonner: 'Benchmark',
    relancer: 'Rerun the benchmark',
    valider: 'Approve the benchmarks',
    relever: 'Fetch the benchmarks',
    completer: 'Complete the benchmarks',
    ouvrir: 'Open its profile',
  },
  suiteDe: '{action} ({pays})',
  vide: 'No country in the export catalogue.',
  aucun: 'No country in this region.',
  sansEtalon: {
    voir: 'See the {n} countries without an approved benchmark',
    masquer: 'Hide countries without an approved benchmark',
  },
}
